<template>
  <v-container class="transparent" fluid>
    <bread-crumb :breadcrumb-data="breadcrumbData"></bread-crumb>
    <v-sheet  class="pa-2 my-6" rounded outlined min-height="600">
          <v-card-text>
            <div class="text-h5">
              <v-icon color="blue" small>mdi-heart</v-icon>
              Downloads Usage
            </div>
            <div>
              This page provides access to signature feature generated by PTMax, which was used for enrichment analysis.
              Criteria: </br>
              1️⃣ signature contains at least 5 sites; </br>
              2️⃣ sites supported by at least 2 publications; </br>
              ✅ Most signatures satisfy both (1️⃣+2️⃣), while a small subset meet only one condition.
            </div>
          </v-card-text>

          <v-sheet class="pa-2">

            <div class="text-h5 text-justify">Files</div>
            <v-sheet rounded outlined class="mt-6">

              <v-simple-table  class="mt-4 " >

                <thead class="text-left ">
                <tr>
                  <th class="text-body-1 font-weight-bold">File name</th>
                  <th class="text-body-1 font-weight-bold">Signature–Site statistics</th>
                  <th class="text-body-1 font-weight-bold">Description</th>
                  <th class="text-body-1 font-weight-bold">Download</th>
                </tr>
                </thead>
                <tbody class="text-left">
                <tr v-for="item in file_stats_dat_add_info" :key="item.name">
                  <td>{{item.file_name}}</td>
                  <td>{{item.file_size}}</td>
                  <td>{{item.desc}}</td>
                  <td><a :href="`/api/get_download_file?file_type=`+item.downtype" style="text-decoration: none">
                    <v-icon>mdi-download</v-icon>
                  </a></td>
                </tr>
                </tbody>

              </v-simple-table>

            </v-sheet>
          </v-sheet>


    </v-sheet>

  </v-container>
</template>

<script>
import BreadCrumb from "@/components/sub/breadcrumb.vue";
import {apiprefix} from "@/main";
export default {
  name: "Download",
  props: [],
  components: {BreadCrumb},
  data() {
    return {
      file_stats_dat:null,
      feature_count:{
        "CancerHallmark": {
          "signature": 10,
          "site_seq_count": 1596
        },
        "Figure": {
          "signature": 282,
          "site_seq_count": 1921
        },
        "CoGene": {
          "signature": 1063,
          "site_seq_count": 5521
        },
        "CoDisease": {
          "signature": 531,
          "site_seq_count": 2921
        },
        "CoChemical": {
          "signature": 720,
          "site_seq_count": 2639
        }
      }

    }
  },
  methods: {},
  mounted() {
  },
  computed:{
    breadcrumbData() {
      return [
        {text: "Home", disabled: false, to: "/"},
        {text: "Download", disabled: true}
      ];
    },
    file_stats_dat_add_info() {
      const mapping = {
        CancerHallmark: {
          file_name: "hsapiens_phosphositeSeq_phosphositeSeq_cancerhallmark.gmt",
          desc: "Cancer Hallmark signatures predicted by BioLinkBERT from text mining, with criteria 1️⃣ 2️⃣",
          downtype: "cancerhallmark"
        },
        Figure: {
          file_name: "hsapiens_phosphositeSeq_phosphositeSeq_figure.gmt",
          desc: "Figure signatures were summarized from figure titles using GPT, with criteria 1️⃣",
          downtype: "cofigure"
        },
        CoGene: {
          file_name: "hsapiens_phosphositeSeq_phosphositeSeq_comention_gene.gmt",
          desc: "Gene co-mentions from text mining, with criteria 1️⃣️ 2️⃣",
          downtype: "cogene"
        },
        CoDisease: {
          file_name: "hsapiens_phosphositeSeq_phosphositeSeq_comention_disease.gmt",
          desc: "Disease co-mentions from text mining, with criteria 1️⃣️ 2️⃣",
          downtype: "codisease"
        },
        CoChemical: {
          file_name: "hsapiens_phosphositeSeq_phosphositeSeq_comention_chemical.gmt",
          desc: "Chemicals co-mentions from text mining, with criteria 1️⃣️ 2️⃣",
          downtype: "cochemical"
        },
      };

      return Object.entries(this.feature_count).map(([key, stats]) => {
        const base = mapping[key];
        return {
          file_name: base.file_name,
          desc: base.desc,
          file_size: `${stats.signature} signatures, ${stats.site_seq_count} seq sites`,
          downtype: base.downtype
        };
      });
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>